/* eslint-disable no-unreachable */
import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  DialogTitle,
  Snackbar,
  Alert,
  LinearProgress,
  FormControl,
  DialogContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Switch,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Label } from 'reactstrap';
import axios from '../../axiosConfig';
import { ReactComponent as Dashboard } from '../../media/dashboard2.svg';
import { ReactComponent as Ops } from '../../media/opsss.svg';
import { ReactComponent as ManageIcon } from '../../media/obm.svg';
import { ReactComponent as MastersIcon } from '../../media/pd.svg';
import { ReactComponent as ReportsIcon } from '../../media/prrd.svg';
import './UserPrivileges.css';
import './animation.css';

const SwitchContainer = ({ children }) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
    spacing={2}
    py={2}
    px={2}
    mb={2}
    elevation={3}
    component={Paper}
    sx={{ backgroundColor: 'inherit ' }}
  >
    {children}
  </Stack>
);

const screenData = [
  {
    OrderID: 1,
    Category: 'Dashboard',
    Type: 'Dashboard',
    ScreenName: 'Dashboard',
    ShortName: 'Dashboard',
    Access: false,
  },
  {
    OrderID: 2,
    Category: 'Production',
    Type: 'Masters',
    ScreenName: 'Garment Category',  
    ShortName: 'Masters_GarmentType',
    Access: false,
  },
  {
    OrderID: 3,
    Category: 'Production',
    Type: 'Masters',
    ScreenName: 'Garment Description', 
    ShortName: 'Masters_Garments',
    Access: false,
  },
  // Garment Type
  //  Garments
  // {
  //   OrderID: 4,
  //   Category: 'Production',
  //   Type: 'Masters',
  //   ScreenName: 'Garment Category',
  //   ShortName: 'Masters_GarmentCategory',
  //   Access: false,
  // },
  {
    OrderID: 5,
    Category: 'Production',
    Type: 'Masters',
    ScreenName: 'Machine',
    ShortName: 'Masters_Machine',
    Access: false,
  },
  {
    OrderID: 6,
    Category: 'Production',
    Type: 'Masters',
    ScreenName: 'Operation Group',
    ShortName: 'Masters_OperationGroup',
    Access: false,
  },
  {
    OrderID: 7,
    Category: 'Production',
    Type: 'Masters',
    ScreenName: 'Operation',
    ShortName: 'Masters_Operation',
    Access: false,
  },
  {
    OrderID: 8,
    Category: 'Production',
    Type: 'Masters',
    ScreenName: 'Rate Card',
    ShortName: 'Masters_RateCard',
    Access: false,
  },
  {
    OrderID: 9,
    Category: 'Production',
    Type: 'Masters',
    ScreenName: 'Batch/Line',
    ShortName: 'Masters_Batch_Line',
    Access: false,
  },
  {
    OrderID: 10,
    Category: 'Production',
    Type: 'Masters',
    ScreenName: 'Grade',
    ShortName: 'Masters_grade',
    Access: false,
  },
  {
    OrderID: 11,
    Category: 'Configuration',
    Type: 'Masters',
    ScreenName: 'Buyer',
    ShortName: 'Masters_Buyer',
    Access: false,
  },
  {
    OrderID: 12,
    Category: 'Configuration',
    Type: 'Masters',
    ScreenName: 'Company',
    ShortName: 'Masters_Company',
    Access: false,
  },
  {
    OrderID: 13,
    Category: 'Configuration',
    Type: 'Masters',
    ScreenName: 'Factory Unit',
    ShortName: 'Masters_FactoryUnit',
    Access: false,
  },
  {
    OrderID: 15,
    Category: 'Configuration',
    Type: 'Masters',
    ScreenName: 'Department',
    ShortName: 'Masters_Department',
    Access: false,
  },
  {
    OrderID: 16,
    Category: 'Configuration',
    Type: 'Masters',
    ScreenName: 'Designation',
    ShortName: 'Masters_Designation',
    Access: false,
  },
  {
    OrderID: 17,
    Category: 'Configuration',
    Type: 'Masters',
    ScreenName: 'User Previledges',
    ShortName: 'Masters_UserPreviledges',
    Access: false,
  },
  {
    OrderID: 18,
    Category: 'Configuration',
    Type: 'Masters',
    ScreenName: 'Access Settings',
    ShortName: 'Masters_AccessSettings',
    Access: false,
  },
  {
    OrderID: 19,
    Category: 'OBProduction',
    Type: 'Transaction',
    ScreenName: 'Operation Bulletin',
    ShortName: 'Transaction_OperationBulletin',
    Access: false,
  },
  {
    OrderID: 20,
    Category: 'OBProduction',
    Type: 'Transaction',
    ScreenName: 'Time & Study',
    ShortName: 'Transaction_Time_and_Study',
    Access: false,
  },
  {
    OrderID: 21,
    Category: 'OBProduction',
    Type: 'Transaction',
    ScreenName: 'Daily Production',
    ShortName: 'Transaction_DailyProduction',
    Access: false,
  },
  {
    OrderID: 22,
    Category: 'OBProduction',
    Type: 'Reports',
    ScreenName: 'Hourly Production',
    ShortName: 'Reports_HourlyProduction',
    Access: false,
  },
  {
    OrderID: 221,
    Category: 'OBProduction',
    Type: 'Reports',
    ScreenName: 'OB Status',
    ShortName: 'Reports_ObStatus',
    Access: false,
  },
  {
    OrderID: 222,
    Category: 'OBProduction',
    Type: 'Reports',
    ScreenName: 'Production Tracker',
    ShortName: 'Reports_ReportTracker',
    Access: false,
  },
  {
    OrderID: 223,
    Category: 'OBProduction',
    Type: 'Reports',
    ScreenName: 'Day Wise Production Cost',
    ShortName: 'Reports_DayWiseProductionCostReport',
    Access: false,
  },
  {
    OrderID: 224,
    Category: 'OBProduction',
    Type: 'Reports',
    ScreenName: 'Employee Cost Analysis',
    ShortName: 'Reports_EmployeeWiseEarning',
    Access: false,
  },
  {
    OrderID: 23,
    Category: 'OBProduction',
    Type: 'Reports',
    ScreenName: 'Monthly Production',
    ShortName: 'Reports_MonthlyProduction',
    Access: false,
  },
  {
    OrderID: 24,
    Category: 'OBProduction',
    Type: 'Reports',
    ScreenName: 'Skill Matrix(Daily)',
    ShortName: 'Reports_SkillMatrixDaily',
    Access: false,
  },
  {
    OrderID: 25,
    Category: 'PRProduction',
    Type: 'Transaction',
    ScreenName: 'Style Rate Card',
    ShortName: 'Transaction_StyleRateCard',
    Access: false,
  },
  {
    OrderID: 26,
    Category: 'PRProduction',
    Type: 'Transaction',
    ScreenName: 'SRC Approval',
    ShortName: 'Transaction_SRCApproval',
    Access: false,
  },
  {
    OrderID: 27,
    Category: 'PRProduction',
    Type: 'Transaction',
    ScreenName: 'PR Production',
    ShortName: 'Transaction_PRProduction',
    Access: false,
  },
  {
    OrderID: 28,
    Category: 'PRProduction',
    Type: 'Reports',
    ScreenName: 'Production Report Card',
    ShortName: 'Reports_ProductionReportCard',
    Access: false,
  },
  {
    OrderID: 29,
    Category: 'PRProduction',
    Type: 'Reports',
    ScreenName: 'Production Hrs Wise',
    ShortName: 'Reports_ProductionHrsWise',
    Access: false,
  },
  {
    OrderID: 30,
    Category: 'PRProduction',
    Type: 'Reports',
    ScreenName: 'Skill Matrix(PR)',
    ShortName: 'Reports_SkillMatrixPR',
    Access: false,
  },
  {
    OrderID: 31,
    Category: 'Configuration',
    Type: 'Masters',
    ScreenName: 'Control Center',
    ShortName: 'Masters_ControlCenter',
    Access: false,
  },
  {
    OrderID: 32,
    Category: 'Configuration',
    Type: 'Masters',
    ScreenName: 'Factory SMV',
    ShortName: 'Masters_FactorySMV',
    Access: false,
  },
  {
    OrderID: 33,
    Category: 'Configuration',
    Type: 'Masters',
    ScreenName: 'Factory Expense',
    ShortName: 'Masters_FactoryExpense',
    Access: false,
  },
  {
    OrderID: 34,
    Category: 'Configuration',
    Type: 'Masters',
    ScreenName: 'Process',
    ShortName: 'Masters_ProcessMst',
    Access: false,
  },
  {
    OrderID: 35,
    Category: 'OBProduction',
    Type: 'Transaction',
    ScreenName: 'Other Process',
    ShortName: 'Transaction_OtherProduction',
    Access: false,
  },
  {
    OrderID: 36,
    Category: 'OBProduction',
    Type: 'Reports',
    ScreenName: 'Process Tracker',
    ShortName: 'Reports_ProcessTracker',
    Access: false,
  },
    {
    OrderID: 37,
    Category: 'OBProduction',
    Type: 'Reports',
    ScreenName: 'Production Cost Insights',
    ShortName: 'Reports_factoryexpensereport',
    Access: false,
  },
    {                 
    OrderID: 38,
    Category: 'OBProduction',
    Type: 'Reports',
    ScreenName: 'Employee Master Report',
    ShortName: 'Reports_ProcessEmpMap',
    Access: false,
    },
    {                 
    OrderID: 39,
    Category: 'OBProduction',
    Type: 'Reports',
    ScreenName: 'Manpower Report',
    ShortName: 'Reports_ManpowerReport',
    Access: false,
    }
];

const AccessControl = () => {
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [openAlert, setopenAlert] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [alertType, setAlertType] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const [expanded, setExpanded] = React.useState(false);
  const [expanded2, setExpanded2] = React.useState(false);
  const [expanded3, setExpanded3] = React.useState(false);
  const [expanded4, setExpanded4] = React.useState(false);
  const [expanded5, setExpanded5] = React.useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [dialogOpenPicker, setDialogOpenPicker] = useState(false);

  // control fields states values
  const [usersData, setusersData] = useState([]);
  const [data, setData] = useState(screenData);
  const [enableAll, setEnableAll] = useState(false);
  const [userSelected, setuserSelected] = React.useState(null);

  const resetFields = () => {
    setData(screenData);
    setuserSelected(null);
    // setuserSelected(null);
  };

  // API Integration
  useEffect(() => {
    getUsers();
  }, []);

  // get all Users Request
  const getUsers = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllUsers/Y', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const data = res.data.filter((i) => i.loginAccess === 'Y');
      setusersData(data);
      setOpenLoader(false);
      // console.log('users', res.data);
    } catch (error) {
      console.error('Error fetching courses:', error);
    }
  };

  // get one UserData Request
  const getOneData = async (user) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetOneUserAccess/${user.UserAccessID}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });

      if (res.data.length > 0) {
        const modifiedData = res.data.map((item) => ({
          OrderID: item.OrderID,
          Category: item.Category,
          Type: item.Type,
          ScreenName: item.ScreenName,
          ShortName: item.ShortName,
          Access: item.Access === 'Y',
        }));

        screenData.forEach((obj2) => {
          const existsInArray1 = modifiedData.some((obj1) => Number(obj1.OrderID) === Number(obj2.OrderID));

          if (!existsInArray1) {
            modifiedData.push(obj2);
          }
        });
        setData(modifiedData);
        setOpenLoader(false);
      } else {
        setOpenLoader(false);
        // setData(screenData);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    }
  };

  const DeleteAndInsertAccess = () => {
    setOpenLoader(true);

    return axios.instance
      .delete(`/DeleteAllAccess/${userSelected.UserAccessID}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(() => {
        const detailPromises = data.map((obj) => {
          const insertData = {
            ...obj,
            Access: obj.Access === true || obj.Access === 'Y' ? 'Y' : 'N',
            UserAccessID: userSelected.UserAccessID,
            CreatedBy: sessionStorage.getItem('UserID'),
          };

          return axios.instance.post('/InsertScreenAccess', insertData, {
            headers: {
              Authorization: tokent,
              'Content-Type': 'application/json',
            },
          });
        });

        return Promise.all(detailPromises)
          .then((detailRes) => {
            setAlertType('success');
            setAlertMessage('User Access Updated Successfully!');
            setopenAlert(true);
            resetFields();
            setTimeout(() => {
              setopenAlert(false);
              setOpenLoader(false);
            }, 2000);
            return detailRes;
          })
          .catch((error) => {
            console.error('Error adding detail data:', error);
            setAlertType('error');
            setAlertMessage('Failed to add detail data.');
            setOpenLoader(false);
            setopenAlert(true);
            return Promise.reject(error);
          });
      })
      .catch((error) => {
        console.error('Error deleting access:', error);
        setAlertType('error');
        setAlertMessage('Failed to delete access.');
        setOpenLoader(false);
        setopenAlert(true);
        return Promise.reject(error);
      });
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleDialogClosePicker = () => {
    setDialogOpenPicker(false);
  };

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const handleExpansion2 = () => {
    setExpanded2((prevExpanded) => !prevExpanded);
  };

  const handleExpansion3 = () => {
    setExpanded3((prevExpanded) => !prevExpanded);
  };

  const handleExpansion4 = () => {
    setExpanded4((prevExpanded) => !prevExpanded);
  };

  const handleExpansion5 = () => {
    setExpanded5((prevExpanded) => !prevExpanded);
  };

  const filteredDataPicker = usersData.filter((enq) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  const handleChangeRowData = (e, index, key, newValue) => {
    // console.log('function called', index, e, key);
    const newData = [...data];
    newData[index][key] = newValue;
    setData(newData);
    // console.log('newData[index][key]', newData[index]);
  };

  const enableAllInCategory = (category, status) => {
    const updatedScreenData = data.map((item) => {
      if (item.Category === category) {
        return { ...item, Access: status };
      }
      return item;
    });
    setData(updatedScreenData);
  };

  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #314755, #26a0da)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              User Access Control
            </Typography>
          </Typography>
        </Grid>

        <Grid container spacing={2} rowSpacing={2} columnSpacing={2} my={2}>
          {userSelected !== null && (
            <Grid item md={12}>
              <Paper elevation={7} sx={{ p: 2, background: 'initial' }}>
                <Typography variant="h5" color="#607d8b" textAlign={'left'} borderBottom={1} pb={1} mx={2}>
                  User Details
                </Typography>

                <Grid
                  container
                  justifyContent={'center'}
                  alignItems={'center'}
                  p={2}
                  rowSpacing={1}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Grid item xs={6}>
                    <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                      <Typography variant="h6" color="GrayText" pr={1}>
                        Employee Code :
                      </Typography>
                      <Typography variant="h6" color="#009688">
                        {userSelected?.UserCode}
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={6}>
                    <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                      <Typography variant="h6" color="GrayText" pr={1}>
                        Name :
                      </Typography>
                      <Typography variant="h6" color="#009688">
                        {userSelected?.UserName}
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={6}>
                    <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                      <Typography variant="h6" color="GrayText" pr={1}>
                        Department :
                      </Typography>
                      <Typography variant="h6" color="#009688" textTransform={'capitalize'}>
                        {userSelected?.DepartmentDescription}
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={6}>
                    <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                      <Typography variant="h6" color="GrayText" sx={{ whiteSpace: 'nowrap' }} pr={1}>
                        Designation :
                      </Typography>
                      <Typography variant="h6" color="#009688">
                        {userSelected?.DesignationDescription}
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={6}>
                    <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                      <Typography variant="h6" color="GrayText" pr={1}>
                        Email :
                      </Typography>
                      <Typography variant="h6" color="#009688" textTransform={'lowercase'}>
                        {userSelected?.Email}
                      </Typography>
                    </Stack>
                  </Grid>

                  <Grid item xs={6}>
                    <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                      <Typography variant="h6" color="GrayText" sx={{ whiteSpace: 'nowrap' }} pr={1}>
                        Phone :
                      </Typography>
                      <Typography variant="h6" color="#009688">
                        {userSelected?.PhoneNumber}
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}
          <Grid item xs={12}>
            <Button
              variant={userSelected === '' ? 'contained' : 'outlined'}
              color={userSelected === '' ? 'warning' : 'primary'}
              fullWidth
              onClick={(e) => {
                setDialogOpenPicker(true);
              }}
            >
              {userSelected === null ? 'Select User to Proceed' : 'Change User'}
            </Button>
          </Grid>
          {userSelected !== null && (
            <>
              <Grid item xs={12}>
                <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4 }}>
                  <Accordion
                    expanded={expanded}
                    disableGutters
                    sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit', py: 1 }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} onClick={handleExpansion} />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      sx={{ borderTop: 'none' }}
                    >
                      <Stack
                        justifyContent={'space-between'}
                        direction={'row'}
                        alignItems={'center'}
                        p={0}
                        m={0}
                        pr={2}
                        width={'100%'}
                      >
                        <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                          <IconButton aria-label="ExpandMoreIcon" color="white">
                            <Dashboard style={{ color: 'white', width: 24, height: 24 }} />
                          </IconButton>
                          <Typography
                            sx={{
                              color: '#36BA98',
                              '&.active': {
                                color: 'text.primary',
                                bgcolor: 'action.selected',
                                fontWeight: 'fontWeightBold',
                              },
                            }}
                            variant="h6"
                          >
                            Dashboard
                          </Typography>
                        </Stack>

                        <Switch
                          checked={data.every((item) => item.Category !== 'Dashboard' || item.Access)}
                          onChange={(event) => enableAllInCategory('Dashboard', event.target.checked)}
                          inputProps={{ 'aria-label': 'controlled' }}
                          color="secondary"
                          size="small"
                          sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': {
                              color: '#36BA98',
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                              backgroundColor: '#C1D8C3',
                            },
                          }}
                        />
                      </Stack>
                    </AccordionSummary>

                    <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
                      <Grid container spacing={2} rowSpacing={2} columnSpacing={2} my={2}>
                        {data.map((row, index) => (
                          <React.Fragment key={index}>
                            {row.Category === 'Dashboard' && (
                              <Grid item xs={12}>
                                <SwitchContainer>
                                  <Label htmlFor="manufacturerbrand" className="text-dark-emphasis">
                                    {row.ScreenName}
                                  </Label>
                                  <input
                                    id={`OutstandingSummary_appicable_${index}`}
                                    className="checkbox2"
                                    type="checkbox"
                                    checked={row.Access}
                                    onClick={(e) => {
                                      const newValue = !row.Access;
                                      handleChangeRowData(e, index, 'Access', newValue);
                                    }}
                                  />
                                </SwitchContainer>
                              </Grid>
                            )}
                          </React.Fragment>
                        ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4 }}>
                  <Accordion
                    expanded={expanded2}
                    disableGutters
                    sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit', py: 1 }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} onClick={handleExpansion2} />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      sx={{ borderTop: 'none' }}
                    >
                      <Stack
                        justifyContent={'space-between'}
                        direction={'row'}
                        alignItems={'center'}
                        p={0}
                        m={0}
                        pr={2}
                        width={'100%'}
                      >
                        <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                          <IconButton aria-label="ExpandMoreIcon" color="white">
                            <MastersIcon style={{ color: 'white', width: 24, height: 24 }} />
                          </IconButton>
                          <Typography
                            sx={{
                              color: '#36BA98',
                              '&.active': {
                                color: 'text.primary',
                                bgcolor: 'action.selected',
                                fontWeight: 'fontWeightBold',
                              },
                            }}
                            variant="h6"
                          >
                            Production
                          </Typography>
                        </Stack>
                        <Switch
                          checked={data.every((item) => item.Category !== 'Production' || item.Access)}
                          onChange={(event) => enableAllInCategory('Production', event.target.checked)}
                          inputProps={{ 'aria-label': 'controlled' }}
                          color="success"
                          size="small"
                          sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': {
                              color: '#36BA98',
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                              backgroundColor: '#C1D8C3',
                            },
                          }}
                        />
                      </Stack>
                    </AccordionSummary>

                    <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
                      <Grid container spacing={2} rowSpacing={2} columnSpacing={2} my={2}>
                        {data.map((row, index) => (
                          <React.Fragment key={index}>
                            {row.Category === 'Production' && (
                              <Grid item md={4} xs={12}>
                                <SwitchContainer>
                                  <Label htmlFor="manufacturerbrand" className="text-dark-emphasis">
                                    {row.ScreenName}
                                  </Label>
                                  <input
                                    id={`SalesMis_appicable_${index}`}
                                    className="checkbox2"
                                    type="checkbox"
                                    checked={row.Access}
                                    onClick={(e) => {
                                      const newValue = !row.Access;
                                      handleChangeRowData(e, index, 'Access', newValue);
                                    }}
                                  />
                                </SwitchContainer>
                              </Grid>
                            )}
                          </React.Fragment>
                        ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4 }}>
                  <Accordion
                    expanded={expanded3}
                    disableGutters
                    sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit', py: 1 }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} onClick={handleExpansion3} />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      sx={{ borderTop: 'none' }}
                    >
                      <Stack
                        justifyContent={'space-between'}
                        direction={'row'}
                        alignItems={'center'}
                        p={0}
                        m={0}
                        pr={2}
                        width={'100%'}
                      >
                        <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                          <IconButton aria-label="ExpandMoreIcon" color="white">
                            <Ops style={{ color: 'white', width: 24, height: 24 }} />
                          </IconButton>
                          <Typography
                            sx={{
                              color: '#36BA98',
                              '&.active': {
                                color: 'text.primary',
                                bgcolor: 'action.selected',
                                fontWeight: 'fontWeightBold',
                              },
                            }}
                            variant="h6"
                          >
                            Configuration
                          </Typography>
                        </Stack>
                        <Switch
                          checked={data.every((item) => item.Category !== 'Configuration' || item.Access)}
                          onChange={(event) => enableAllInCategory('Configuration', event.target.checked)}
                          inputProps={{ 'aria-label': 'controlled' }}
                          color="success"
                          size="small"
                          sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': {
                              color: '#36BA98',
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                              backgroundColor: '#C1D8C3',
                            },
                          }}
                        />
                      </Stack>
                    </AccordionSummary>

                    <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
                      <Grid container spacing={2} rowSpacing={2} columnSpacing={2} my={2}>
                        {data.map((row, index) => (
                          <React.Fragment key={index}>
                            {row.Category === 'Configuration' && (
                              <Grid item md={4} xs={12}>
                                <SwitchContainer>
                                  <Label htmlFor="manufacturerbrand" className="text-dark-emphasis">
                                    {row.ScreenName}
                                  </Label>
                                  <input
                                    id={`PurchaseMis_appicable_${index}`}
                                    className="checkbox2"
                                    type="checkbox"
                                    checked={row.Access}
                                    onClick={(e) => {
                                      const newValue = !row.Access;
                                      handleChangeRowData(e, index, 'Access', newValue);
                                    }}
                                  />
                                </SwitchContainer>
                              </Grid>
                            )}
                          </React.Fragment>
                        ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4 }}>
                  <Accordion
                    expanded={expanded4}
                    disableGutters
                    sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit', py: 1 }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} onClick={handleExpansion4} />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      sx={{ borderTop: 'none' }}
                    >
                      <Stack
                        justifyContent={'space-between'}
                        direction={'row'}
                        alignItems={'center'}
                        p={0}
                        m={0}
                        pr={2}
                        width={'100%'}
                      >
                        <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                          <IconButton aria-label="ExpandMoreIcon" color="white">
                            <ManageIcon style={{ color: 'white', width: 24, height: 24 }} />
                          </IconButton>
                          <Typography
                            sx={{
                              color: '#36BA98',
                              '&.active': {
                                color: 'text.primary',
                                bgcolor: 'action.selected',
                                fontWeight: 'fontWeightBold',
                              },
                            }}
                            variant="h6"
                          >
                            OB Production
                          </Typography>
                        </Stack>
                        <Switch
                          checked={data.every((item) => item.Category !== 'OBProduction' || item.Access)}
                          onChange={(event) => enableAllInCategory('OBProduction', event.target.checked)}
                          inputProps={{ 'aria-label': 'controlled' }}
                          color="success"
                          size="small"
                          sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': {
                              color: '#36BA98',
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                              backgroundColor: '#C1D8C3',
                            },
                          }}
                        />
                      </Stack>
                    </AccordionSummary>

                    <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
                      <Grid container spacing={2} rowSpacing={2} columnSpacing={2} my={2}>
                        {data.map((row, index) => (
                          <React.Fragment key={index}>
                            {row.Category === 'OBProduction' && (
                              <Grid item md={4} xs={12}>
                                <SwitchContainer>
                                  <Label htmlFor="manufacturerbrand" className="text-dark-emphasis">
                                    {row.ScreenName}
                                  </Label>
                                  <input
                                    id={`InventoryMis_appicable_${index}`}
                                    className="checkbox2"
                                    type="checkbox"
                                    checked={row.Access}
                                    onClick={(e) => {
                                      const newValue = !row.Access;
                                      handleChangeRowData(e, index, 'Access', newValue);
                                    }}
                                  />
                                </SwitchContainer>
                              </Grid>
                            )}
                          </React.Fragment>
                        ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4 }}>
                  <Accordion
                    expanded={expanded5}
                    disableGutters
                    sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit', py: 1 }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} onClick={handleExpansion5} />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                      sx={{ borderTop: 'none' }}
                    >
                      <Stack
                        justifyContent={'space-between'}
                        direction={'row'}
                        alignItems={'center'}
                        p={0}
                        m={0}
                        pr={2}
                        width={'100%'}
                      >
                        <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                          <IconButton aria-label="ExpandMoreIcon" color="white">
                            <ReportsIcon style={{ color: 'white', width: 24, height: 24 }} />
                          </IconButton>
                          <Typography
                            sx={{
                              color: '#36BA98',
                              '&.active': {
                                color: 'text.primary',
                                bgcolor: 'action.selected',
                                fontWeight: 'fontWeightBold',
                              },
                            }}
                            variant="h6"
                          >
                            PR Production
                          </Typography>
                        </Stack>
                        <Switch
                          checked={data.every((item) => item.Category !== 'PRProduction' || item.Access)}
                          onChange={(event) => enableAllInCategory('PRProduction', event.target.checked)}
                          inputProps={{ 'aria-label': 'controlled' }}
                          color="success"
                          size="small"
                          sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': {
                              color: '#36BA98',
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                              backgroundColor: '#C1D8C3',
                            },
                          }}
                        />
                      </Stack>
                    </AccordionSummary>

                    <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
                      <Grid container spacing={2} rowSpacing={2} columnSpacing={2} my={2}>
                        {data.map((row, index) => (
                          <React.Fragment key={index}>
                            {row.Category === 'PRProduction' && (
                              <Grid item md={4} xs={12}>
                                <SwitchContainer>
                                  <Label htmlFor="manufacturerbrand" className="text-dark-emphasis">
                                    {row.ScreenName}
                                  </Label>
                                  <input
                                    id={`InventoryMis_appicable_${index}`}
                                    className="checkbox2"
                                    type="checkbox"
                                    checked={row.Access}
                                    onClick={(e) => {
                                      const newValue = !row.Access;
                                      handleChangeRowData(e, index, 'Access', newValue);
                                    }}
                                  />
                                </SwitchContainer>
                              </Grid>
                            )}
                          </React.Fragment>
                        ))}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2} my={2}>
                  <Button
                    variant="contained"
                    color="success"
                    sx={{ boxShadow: 1, backgroundColor: '#36BA98', color: 'white' }}
                    onClick={DeleteAndInsertAccess}
                  >
                    Save
                  </Button>
                </Stack>
              </Grid>
            </>
          )}
        </Grid>
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

      {/* Select Operation Bulletin */}
      <Dialog open={dialogOpenPicker} onClose={handleDialogClosePicker} maxWidth="md" fullWidth>
        <DialogTitle>Select User to Control </DialogTitle>
        <DialogContent>
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Search"
                size="small"
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
              />
            </FormControl>
          </Stack>
          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>
                  <TableCell align="left">Emp Code</TableCell>
                  <TableCell align="left">Name</TableCell>
                  <TableCell align="left">Department</TableCell>
                  <TableCell align="left">Designation</TableCell>
                  <TableCell align="center">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredDataPicker.map((user, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">{user.SNo}</TableCell>
                    <TableCell align="left">{user.UserCode}</TableCell>
                    <TableCell align="left">{user.UserName}</TableCell>
                    <TableCell align="left">{user.DepartmentDescription}</TableCell>
                    <TableCell align="left">{user.DesignationDescription}</TableCell>
                    <TableCell align="center" sx={{ padding: '0' }}>
                      <Button
                        variant="outlined"
                        size="small"
                        color="primary"
                        onClick={() => {
                          setuserSelected(user);
                          getOneData(user);
                          setDialogOpenPicker(false);
                          setExpanded(true);
                          setExpanded2(true);
                          setExpanded3(true);
                          setExpanded4(true);
                          setExpanded5(true);
                        }}
                      >
                        Select
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AccessControl;
